const ETproblemStatements = [
  {
    statementId: "ET1",
    problemStatement:
      "In today’s education system, students develop skills through hackathons, internships, projects, and self-learning but there is no unified platform that accurately reflects their true capabilities. Recruiters and colleges still rely heavily on marks, overlooking practical skills and real-world experience. Imagine a system that evaluates and showcases a student’s overall credibility combining academics with real achievements into one trusted score.",
    exampleFeatures: [
      "Unified Student Profile: Combines academics, projects, hackathons, internships, and certifications in one place.",
      "Dynamic Credibility Score: Generates a score with detailed category-wise breakdown (skills, experience, academics).",
      "Public Shareable Profile: Provides a portfolio-like link that students can share with recruiters or colleges.",
      "Verification System: Allows users to upload proofs such as certificates, GitHub links, and project demos for authenticity.",
      "Project Evaluation: Analyzes GitHub repositories and activity to assess project quality and impact."
    ],
    extracontent:
      "Focus on proof-based student identity, not just marks-based evaluation."
  },
  {
    statementId: "ET2",
    problemStatement:
      "Students often face clashing deadlines such as assignments, exams, and hackathons leading to stress and missed work. There is no intelligent system to manage and resolve these conflicts. Imagine a smart tool that organizes deadlines, detects overlaps, and creates an optimized plan to keep students on track.",
    exampleFeatures: [
      "Deadline Input System: Add all upcoming deadlines including assignments, exams, and events.",
      "Visual Conflict Calendar: Clearly displays overlapping deadlines.",
      "Priority-Based Scheduling: Assign importance levels to tasks for better planning.",
      "Smart Reminders: Get timely alerts to avoid missing deadlines.",
      "Optimal Task Sequencing: Suggests the best order to complete tasks."
    ],
    extracontent:
      "Focus on resolving deadline conflicts intelligently, not just tracking tasks."
  },
  {
    statementId: "ET3",
    problemStatement:
      "In today’s competitive job market, students often apply for internships and jobs without knowing if they are truly prepared, leading to repeated rejections and frustration. There is no system that objectively evaluates real interview readiness. Imagine a smart tool that assesses your skills, analyzes your work, and tells you honestly whether you’re ready along with what to improve.",
    exampleFeatures: [
      "Role Selection: Choose a target role (e.g., frontend developer, data analyst).",
      "Skill Checklist: View required skills and competencies for the selected role.",
      "Self-Assessment + Proof Upload: Rate your skills and upload projects, resumes, or GitHub links as proof.",
      "Readiness Score: Get a clear score indicating how prepared you are for the role.",
      "Improvement Suggestions: Provides actionable recommendations to improve weak areas."
    ],
    extracontent:
      "Focus on honest interview readiness, not just application preparation."
  },
  {
    statementId: "ET4",
    problemStatement:
      "In today’s academic environment, students often struggle to revise large volumes of study material efficiently, leading to poor retention and last-minute stress. Imagine a platform that uses AI to convert lengthy content into concise, easy-to-understand revision notes making studying faster and smarter.",
    exampleFeatures: [
      "AI Text Summarization: Converts long chapters into short, meaningful summaries.",
      "Keyword Extraction: Highlights important concepts and terms for quick recall.",
      "Quick Revision Notes Generation: Creates simplified notes ideal for last-minute revision.",
      "Downloadable Reports: Allows users to download summaries for offline use.",
      "Subject Categorization: Organizes content based on subjects and topics.",
      "Admin Content Management Panel: Enables management and uploading of study materials."
    ],
    extracontent:
      "Focus on faster and smarter revision, not just content consumption."
  }
];

export default ETproblemStatements;